import { Injectable } from '@angular/core';
import { BankAccount, HorizontalListData, HorizontalListFactory } from 'common';

@Injectable()
export class TransferBankAccountWidgetAdapter {
  adaptListData = (data: BankAccount): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Bank name',
        displayedValue: data?.bankName,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Routing',
        displayedValue: data?.routingNumber,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Account number',
        displayedValue: data?.accountNumber,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Status',
        displayedValue: data?.isVerified ? 'Verified' : 'Unverified',
      }),
    ];
  };
}
